import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { ContractDetailComponent } from './contract-detail/contract-detail.component';
import { ContractListComponent } from './contract-list/contract-list.component';
import { RightsGuard } from 'src/app/core/guards/rights.guard';

const routes: Routes = [
  {
    path: 'contracts',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: '', component: ContractListComponent },
      { path: ':id', component: ContractDetailComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class ContractsRoutingModule {}
